export default __webpack_public_path__ + "static/media/3c.09d8f7af.jpg";